import { combineReducers } from 'redux';

import Column from './column';
import Report from './report';
import Table from './table';
import User from './user';
import chatSlice from '../chat/slice'; // Імпортуємо слайс, який містить chatSlice.reducer
import wsSlice from '../ws/slice'; // Імпортуємо слайс, який містить chatSlice.reducer

export default combineReducers({
  Column,
  Report,
  Table,
  User,
  chat: chatSlice.reducer,
  ws: wsSlice.reducer,
});
